module.exports = __webpack_public_path__ + "assets/house-dark.d9a7e89c.svg";